

export const RISK_LEVELS = [
  {
    value: 'high',
    label: 'High Risk',
    color: 'bg-red-50 text-red-700',
    description: 'Patient may need urgent outreach',
  },
  {
    value: 'medium',
    label: 'Medium Risk',
    color: 'bg-yellow-50 text-yellow-700',
    description: 'Patient should be reviewed soon',
  },
  {
    value: 'low',
    label: 'Low Risk',
    color: 'bg-green-50 text-green-700',
    description: 'Patient is stable, no immediate action needed',
  },
];
